var render = function render(){var _vm=this,_c=_vm._self._c;return _c('k-breadcrumb',[_c('b-breadcrumb-item',{staticClass:"homeIcon"},[_c('b-icon',{attrs:{"icon":"house-fill"}}),_c('span',{staticStyle:{"display":"none"}},[_vm._v("wcag")])],1),_vm._l((_vm.routeName),function(item){return _c('b-breadcrumb-item',{key:item.id,attrs:{"to":item.to,"active":item.active}},[_vm._v(" "+_vm._s(item.text)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }